import React, { Component } from 'react';
import ToggleLeftMenu from '../components/ToggleLeftMenu';
import RouterLibrary from '../RouterLibrary';
import image from '../images/logo.png';
import '../style/custom.css';
import { Dropdown } from "react-bootstrap";
import Footer from '../components/Footer';
import { Scrollbars } from 'react-custom-scrollbars-2';
import TopBar from '../components/TopBar';
import HomePage from './HomePage';
import LeftMenu from '../components/LeftMenu';
import TotalProcessed from './TotalProcessed';


export default function TotalProcess(prop) {


    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                        <TotalProcessed />
                    <Footer />
                </div>
            </div>
        </>

    )
}
